import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import {Common} from '../../shared/common';
@Component({
  selector: 'vc-poll-finished-summary',
  templateUrl: 'poll-finished-summary.component.html',
  styleUrls: ['./poll-finished-summary.component.less', '../../shared/common.less']
})

export class PollFinishedSummaryComponent implements OnInit {
  @Input() description: string;
  @Input() startDate: string;
  @Input() endDate: string;
  @Input() votersCount: number;
  @Input() votersVoted: number;
  @Input() participation: string;
  @Input() resultsShared: boolean;
  @Input() isShareEnabled: boolean;
  @Input() endDateFormat: Date;
  @Input() calculating: boolean;
  @Input() isActive = false;
  @Input() quorum: number;
  @Input() live = false;
  @Input() participants: number;
  @Input() displayDownload = true;
  @Output() downloadVoters = new EventEmitter<boolean>();
  @Output() shareResults = new EventEmitter<boolean>();
  @Output() return = new EventEmitter<boolean>();
  @Output() displayVoters = new EventEmitter<string>();
  @Input() type = 'live';
  blockchainLink: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public common: Common,
  ) {
  }

  navigateToAudit() {
    this.route.queryParams
      .subscribe(params => {
        const pollId = params['poll'];
        this.router.navigate(['/poll-audit/' + pollId])
      });
  }

  rejoin() {
    this.return.emit(true);
  }

  download() {
    this.downloadVoters.emit(true);
  }

  shareResult() {
    this.shareResults.emit(true);
  }

  sendVoterMessage(message: string) {
    this.displayVoters.emit(message);
  }

  getQuorum() { return this.quorum != null ? this.quorum : '-'; }

  ngOnInit() {
    let pollId = '';
    this.route.queryParams.subscribe((params) => {
      pollId = params.poll;
    });
    this.blockchainLink = environment.settings.validation + pollId + this.common.getNewEnvironmentString();
  }
}
